export const getIconUrl = (iconPath: string) => {
  return new URL(`../static/icons/${iconPath}.svg`, import.meta.url).href;
};
